import { request } from '@@/plugin-request';

export async function signin(data) {
  return request('/api/auth/signin', {
    method: 'POST',
    data,
  });
}

export async function smsTwoFactor(data) {
  return request('/api/auth/twoFactor', {
    method: 'POST',
    data,
  });
}

export async function twoFactorVerify(data) {
  return request('/api/auth/twoFactorVerify', {
    method: 'POST',
    data,
  });
}

export async function refresh() {
  const response = await fetch('/api/auth/refresh', {
    method: 'POST',
    credentials: 'include',
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.message || `HTTP ${response.status}`);
    error.response = {
      status: response.status,
      data,
    };
    throw error;
  }

  return data;
}

export async function signout() {
  return request('/api/auth/signout', {
    method: 'POST',
  });
}

export async function listServiceAccounts() {
  return request('/api/service-accounts', {
    method: 'GET',
  });
}

export async function createServiceAccount(data) {
  return request('/api/service-accounts', {
    method: 'POST',
    data,
  });
}

export async function deleteServiceAccount(id) {
  return request(`/api/service-accounts/${id}`, {
    method: 'DELETE',
  });
}

export async function createServiceAccountKey(id, data) {
  return request(`/api/service-accounts/${id}/api-keys`, {
    method: 'POST',
    data,
  });
}

export async function regenerateServiceAccountKey(accountId, keyId) {
  return request(`/api/service-accounts/${accountId}/regenerate-key`, {
    method: 'POST',
    data: { keyId },
  });
}

export async function listAllApiKeys(type, userId) {
  const params = {};
  if (type) params.type = type;
  if (userId) params.userId = userId;
  return request('/api/api-keys', {
    method: 'GET',
    params,
  });
}

export async function revokeApiKey(id) {
  return request(`/api/api-keys/${id}`, {
    method: 'DELETE',
  });
}

export async function listMyApiKeys() {
  return request('/api/api-keys/my', {
    method: 'GET',
    timeout: 15_000,
  });
}

export async function createMyApiKey(data) {
  return request('/api/api-keys/my', {
    method: 'POST',
    data,
  });
}

export async function renewMyApiKey(id) {
  return request(`/api/api-keys/my/${id}/renew`, {
    method: 'POST',
  });
}

export async function revokeMyApiKey(id) {
  return request(`/api/api-keys/my/${id}`, {
    method: 'DELETE',
  });
}

export async function listDevices() {
  return request('/api/auth/devices', {
    method: 'GET',
  });
}

export async function getGiteaWebAccess() {
  return request('/api/auth/gitea-web-access', {
    method: 'GET',
  });
}

export async function setGiteaWebPassword(password) {
  return request('/api/auth/gitea-web-password', {
    method: 'PUT',
    data: { password },
  });
}

export async function revokeDevice(id) {
  return request(`/api/auth/devices/${id}`, {
    method: 'DELETE',
  });
}

export async function revokeAllDevices() {
  return request('/api/auth/devices', {
    method: 'DELETE',
  });
}

export async function createSavvyDeskPairingCode() {
  return request('/api/auth/savvydesk-pairing-code', {
    method: 'POST',
  });
}

export async function listSavvyDeskPairingCodes() {
  return request('/api/auth/savvydesk-pairing-code', {
    method: 'GET',
  });
}

//检查是否关联
export async function checkConnect(data) {
  return request('/api/wechat/connected', {
    method: 'POST',
    data,
  });
}

//更改忘记密码
export async function changeForgetPassword(data) {
  return request('/api/auth/changeForgetPassword', {
    method: 'PUT',
    data,
  });
}
